import React, { useCallback, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { TabPanel } from '../../../components/other/Tab/TabPanel';
import { ButtonWithLoader } from '../../../components/ui/Buttons';
import { useFormikRegistration } from '../hooks/useFormikRegistration';
import { useShowErrors } from '../../../hooks/useShowErrors';
import { TAuthTabs } from '.';
import { useAxiosRegistrations } from '../hooks/useAxiosRegistration';
import TermDialog from '../../../components/other/Dialog/TermDialog';

const BUYER_ROLE = 'ROLE_BUYER';

interface IProps {
  changeAuthTab: (newTab: TAuthTabs, props?: any) => void;
  initTab: number;
  initEmail?: string;
  isDialog?: boolean;
}

export const Registration: React.FC<IProps> = ({
  changeAuthTab,
  initTab,
  initEmail,
}) => {
  const intl = useIntl();
  const [tab, setTab] = useState(initTab);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContentType, setDialogContentType] = useState('');
  const { data, loading, err, makeRequestReg, requestedType } = useAxiosRegistrations();
  const formik = useFormikRegistration(tab, initEmail, makeRequestReg, BUYER_ROLE);

  useEffect(() => {
    localStorage.setItem('alignment', BUYER_ROLE);
  }, []);

  useEffect(() => {
    if (data) {
      changeAuthTab('EmailSent', { email: formik.values.email });
    }
  }, [data, requestedType, formik.values.email]);

  useShowErrors([err]);

  const handleDialogOpen = useCallback(
    (contentType: string) => {
      setDialogContentType(contentType);
      setOpenDialog(true);
    },
    [setDialogContentType, setOpenDialog]
  );

  return (
    <>
      <div className='kt-login__body' style={{ position: 'relative' }}>
        <div className='kt-login__form'>
          <div className='kt-login__title'>
            <h3>
              {intl.formatMessage({
                id: 'AUTH.REGISTER.NEW_USER.BUYER',
              })}
            </h3>
          </div>

          <form
            noValidate
            autoComplete='off'
            className='kt-form'
            onSubmit={formik.handleSubmit}
          >
            <TabPanel value={tab} index={0} p={0}>
              <div className='form-group'>
                <TextField
                  type='text'
                  label={intl.formatMessage({ id: 'AUTH.INPUT.EMAIL' })}
                  margin='normal'
                  className='kt-width-full'
                  name='email'
                  variant='outlined'
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  helperText={formik.touched.email && formik.errors.email}
                  error={Boolean(formik.touched.email && formik.errors.email)}
                />
              </div>
              <div className='form-group'>
                <p>{intl.formatMessage({ id: 'AUTH.REGISTER.EMAIL.INFO' })}</p>
              </div>
            </TabPanel>

            <div className='kt-login__actions' style={{ margin: '32px 0' }}>
              <ButtonWithLoader
                style={{
                  width: '100%',
                  backgroundColor: !formik.values.email ? '#7c97c080' : '#205373',
                  color: '#fff',
                }}
                onPress={formik.handleSubmit}
                disabled={!formik.values.email}
                loading={loading}
              >
                {intl.formatMessage({ id: 'AUTH.GENERAL.SIGNUP_BUTTON' })}
              </ButtonWithLoader>
            </div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Link
                to='#'
                onClick={() => changeAuthTab('CheckInSystem')}
                className='kt-link kt-login__link-forgot'
                style={{ color: '#006997' }}
              >
                {intl.formatMessage({ id: 'AUTH.REGISTER.LOGIN_WITH_PASSWORD' })}
              </Link>
            </div>
          </form>
          <div className='kt-login__menu' style={{ textAlign: 'center', marginTop: 20 }}>
            <p style={{ color: '#0d0a05' }}>
              Нажимая на кнопку Зарегистрироваться, Вы соглашаетесь с{' '}
              <a
                className='kt-link'
                onClick={() => handleDialogOpen('privacy_policy')}
                style={{ marginRight: 0, whiteSpace: 'nowrap' }}
              >
                <FormattedMessage id='AUTH.LOGIN.PRIVACY_POLICY' />
              </a>{' '}
              и на обработку ваших{' '}
              <a
                className='kt-link'
                onClick={() => handleDialogOpen('user_agreement')}
                style={{ marginRight: 0, whiteSpace: 'nowrap' }}
              >
                <FormattedMessage id='AUTH.LOGIN.LEGAL_TERMS' />
              </a>
            </p>
          </div>
        </div>
      </div>
      <TermDialog
        isOpen={openDialog}
        handleClose={() => setOpenDialog(false)}
        contentType={dialogContentType}
      />
    </>
  );
};
